'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableListContainer = exports.expandableListBuilder = undefined;

var _reactRedux = require('react-redux');

var _ExpandableList = require('../../Presentational components/ExpandableList/ExpandableList');

var _ExpandableList2 = _interopRequireDefault(_ExpandableList);

var _actions = require('./actions');

var Actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var expandableListBuilder = exports.expandableListBuilder = function expandableListBuilder(mapStateToProps) {
  return (0, _reactRedux.connect)(mapStateToProps, Actions)(_ExpandableList2.default);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    lists: state.app.lists
  };
};

var ExpandableListContainer = exports.ExpandableListContainer = expandableListBuilder(mapStateToProps);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/ExpandableListContainer/ExpandableListContainer.js
 ** module id = 467
 ** module chunks = 0
 **/